import fpautopartsDefaults from '../jm1erforss-1/config.js';

const widgetsToRemove = [
  'HeaderVehicleWidget_miniStore',
  'HeaderVehicleWidget_miniStore2',
  'FacetPanelCategory',
];

export default {
  includes: ['jm1erforss-1'],
  ...fpautopartsDefaults,
  fitmentSearch: {
    ...fpautopartsDefaults.fitmentSearch,
    categorySelectionPages: [
      { pathname: '/vehicle/', field: 'category' },
      { pathname: '/parts/', field: 'category' },
    ],
  },
  product: {
    noImageSrc: '/product_images/uploaded_images/productdefault.jpg',
  },
  Widgets: [
    ...fpautopartsDefaults.Widgets.filter((w) => !widgetsToRemove.includes(w.name)),
    {
      name: 'FacetPanelCategory',
      type: 'FacetPanel',
      location: {
        firstChildOf: '#grid-list-layout .container',
        class: 'cm_facet-panel-category',
      },
      template: 'FacetPanelContainer',
      ignoreFields: ['Submodel', 'category_full'],
    },
  ],
};
